import { NgModule } from '@angular/core';


import { AdminComponent } from './admin/admin.component';
import { BreadcrumbsComponent } from './breadcrumb/breadcrumb.component';
import { FavoritesComponent } from './toolbar/favorites/favorites.component';
import { IconSidenavDirective } from './sidenav/icon-sidenav.directive';
import { LoadingOverlayComponent } from './loading-overlay/loading-overlay.component';
import { QuickpanelComponent } from './quickpanel/quickpanel.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { SidenavItemComponent } from './sidenav/sidenav-item/sidenav-item.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { FileManagerBreadcrumbComponent } from './file-manager-breadcrumb/file-manager-breadcrumb.component';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSidenavModule } from '@angular/material/sidenav';
import { UserMenuComponent } from '../shared/user-menu/user-menu.component';
import { UISectionTitleComponent } from '../shared/ui-section-title/ui-section-title.component';

@NgModule({
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatDividerModule,
    MatListModule,
    MatToolbarModule,
    MatMenuModule,
    MatTooltipModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollingModule, // for `cdkScrollable` on the #main-container in the admin component
    MatSidenavModule,
    UserMenuComponent,
    UISectionTitleComponent,
  ],
  declarations: [
    SidenavComponent,
    SidenavItemComponent,
    IconSidenavDirective,
    BreadcrumbsComponent,
    AdminComponent,
    QuickpanelComponent,
    LoadingOverlayComponent,
    ToolbarComponent,
    FavoritesComponent,
    FileManagerBreadcrumbComponent,
  ],
  exports: [
    SidenavComponent,
    SidenavItemComponent,
    IconSidenavDirective,
    BreadcrumbsComponent,
    AdminComponent,
    QuickpanelComponent,
    LoadingOverlayComponent,
    ToolbarComponent,
    FavoritesComponent,
    FileManagerBreadcrumbComponent,
  ]


})
export class FuryCoreModule { }
